import React from "react";

const Plus = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M15.714 15.714V2h4.572v13.714H34v4.572H20.286V34h-4.572V20.286H2v-4.572h13.714z"
          fill={fill}
      />
    </svg>
);

export default Plus;